module.exports = __webpack_public_path__ + "img/astro1.45607594.jpg";